import { useCallback, useEffect, useRef, useState } from 'react'

const useFullscreen = () => {
  const elementRef = useRef(null)
  const [isFullscreen, setIsFullscreen] = useState(false)

  const triggerFullscreen = useCallback(() => {
    const elem = elementRef.current

    if (!elem) return

    if (elem.requestFullscreen) {
      elem.requestFullscreen()
    } else if (elem.webkitRequestFullscreen) {
      /* Safari */
      elem.webkitRequestFullscreen()
    } else if (elem.msRequestFullscreen) {
      /* IE11 */
      elem.msRequestFullscreen()
    }
    setIsFullscreen(true)
  }, [])

  const exitFullscreen = useCallback(() => {
    if (!isFullscreen) return
    if (document.exitFullscreen) {
      document.exitFullscreen()
    } else if (document.webkitExitFullscreen) {
      document.webkitExitFullscreen()
    } else if (document.msExitFullscreen) {
      document.msExitFullscreen()
    }
    setIsFullscreen(false)
  }, [isFullscreen])

  useEffect(() => {
    const handleExit = () => {
      // Check if ANY element is currently in fullscreen
      const isCurrentlyFull = !!(
        document.fullscreenElement ||
        document.webkitFullscreenElement ||
        document.msFullscreenElement
      )

      setIsFullscreen(isCurrentlyFull)
    }

    // Listen for all browser variations of the change event
    document.addEventListener('fullscreenchange', handleExit)
    document.addEventListener('webkitfullscreenchange', handleExit)
    document.addEventListener('mozfullscreenchange', handleExit)
    document.addEventListener('MSFullscreenChange', handleExit)

    return () => {
      document.removeEventListener('fullscreenchange', handleExit)
      document.removeEventListener('webkitfullscreenchange', handleExit)
      document.removeEventListener('mozfullscreenchange', handleExit)
      document.removeEventListener('MSFullscreenChange', handleExit)
    }
  }, [])

  return { isFullscreen, elementRef, triggerFullscreen, exitFullscreen }
}

export default useFullscreen
